import { RefObject } from 'react';

export default class AbstractPlayerInterface {
  ref: RefObject<HTMLVideoElement>;
  constructor(ref: RefObject<HTMLVideoElement>) {
    this.ref = ref;
  }
  load() {
    this.ref.current.load();
  }
  async play() {
    await this.ref.current.play();
  }
  pause() {
    this.ref.current.pause();
  }
  stop() {
    this.ref.current.pause();
  }
  setCurrentTime(currentTime) {
    this.ref.current.currentTime = currentTime;
  }
  getCurrentTime() {
    return this.ref.current.currentTime;
  }
  getDuration() {
    return this.ref.current.duration;
  }
}
